module.exports = __webpack_public_path__ + "img/c03_unitlongswordsman_Normal_ua.ebea733a.webp";